'use client';

import React from "react";
import DisplayMedia from "../components/media-display";
import AppBarBar from "../components/AppBar";
import FooterPage from "../components/FooterPage";

const items = [
    {
        res: 'media/np1.jpeg',
        isImg: true,
        description: 'Awareness creation for the new pulse crop..'
    },
    {
        res: 'media/np2.jpeg',
        isImg: true,
        description: 'Sensitizing the public about the new pulse crop in Southeastern Nigeria.'
    },
    {
        res: 'media/np3.jpeg',
        isImg: true,
        description: 'Taking the pulse crop to the rural areas of Abia State, Nigeria.'
    },
    {
        res: 'media/np4.jpeg',
        isImg: true,
        description: 'Campaign for increased cultivation and consumption of pulse.'
    },    
];

function PublicCampaign() {
    return (
        <div className="bg-canvas min-h-screen flex flex-col justify-between">
            <div>
                {/* Navigation */}
                <AppBarBar />

                {/* Hero / Header Section */}
                <div className="bg-forest text-canvas pt-32 pb-16 sm:pt-40 sm:pb-20">
                    <div className="max-w-6xl mx-auto px-6 sm:px-8">
                        <p className="text-grain font-semibold text-xs uppercase tracking-[0.2em] mb-3">
                            Our Impact
                        </p>
                        <h1 className="font-display text-4xl sm:text-5xl mb-4 max-w-xl">
                            Public Campaign
                        </h1>
                        <p className="text-canvas/70 max-w-lg">
                            Sensitizing, mobilizing, and driving healthy agricultural transformation across rural and urban communities.
                        </p>
                    </div>
                </div>

                {/* Campaign Gallery Grid */}
                <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-20">
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {items.map((item, index) => (
                            <DisplayMedia 
                                key={index} 
                                src={item.res} 
                                isImg={item.isImg} 
                                description={item.description}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* Standardized Footer Layout */}
            <FooterPage preFooter={true} />
        </div>
    );
}

export default PublicCampaign;